var render = function render(){var _vm=this,_c=_vm._self._c;return _c('landing-page',{attrs:{"chamber":"president","chamberTitle":"President","loading":_vm.loading,"models":_vm.presidentModels,"currentModel":_vm.presidentModel,"landingModels":_vm.presidentLandingModels}},[_c('span',{attrs:{"slot":"page-title"},slot:"page-title"},[_vm._v("2020 Presidential Election Model")])])
}
var staticRenderFns = []

export { render, staticRenderFns }